/* tslint:disable */
/* eslint-disable */
export enum AdminAuthState {
  NEEDS_SIGNIN,
  ATTEMPTING_SIGNIN,
  SIGNED_IN,
  SIGNIN_FAILED,
  NOT_IN_USE
}
